/**
 * Created by chenzheyu on 2017/6/21.
 */
import daijia from '../../../api/daijia/daijia'
import initdata from '../../../api/initdata'
import Vue from 'vue'

const state = {
  waiterList: null,
  orderNum: null,
  budgetCost: null,
  couponList: [],
  orderDetails: null,
  payInfo: null,
  AllOrder: {
    state: true,
    total: true,
    val: []
  },
  orderFee: {}, // 支付信息
  queryReview: null
}

const mutations = {
  DJMakeAnAppointment (state, data) {
  },
  queryOrder (state, data) {
    state.orderNum = data
  },
  DjBudgetCost (state, data) {
    state.budgetCost = data
  },
  DjOrderInfo (state, data) {
    if(data.code === 1) {
      if(data.order.book_time) {
        data.order.book_time = data.order && data.order.book_time ? Vue.prototype.$utils.TimestampDate(data.order.book_time) : ''
      } else {
        data.order.book_time = ''
      }
      state.orderDetails = data.order
      data.orderFee['total_fee'] = data.orderFee.total_fee || 0
      state.orderFee = data.orderFee
    }
  },
  DjPayInfo (state, data) {
    state.payInfo = data.data
  },
  DjQueryAllOrder (state, obj) {
    let type = obj.type
    let data = obj.data
    if (data && data.code === 1) {
      state.AllOrder.total = (data.finnishTotal || 0) + (data.runTotal || 0)
      state.AllOrder.state = false
      if (type === 'upData') {
        state.AllOrder.val = []
      }
      if (data.runOrders) {
        data.runOrders.forEach((row) => {
          state.AllOrder.val.push(row)
        })
      }
      if (data.finishOrders) {
        data.finishOrders.forEach((row) => {
          state.AllOrder.val.push(row)
        })
      }
    }
  },
  DjQueryReview (state, data) {
    if (data && data.data && data.data.content !== '') {
      let tabs = data.data.content.substring(0, data.data.content.lastIndexOf('&*&'))
      tabs = tabs !== '' ? tabs.split('&|&') : []
      state.queryReview = {
        reviewContent: data.data.content.substring(data.data.content.lastIndexOf('&*&')).replace('&*&', ''),
        tabs: tabs.length > 0 ? tabs : null,
        score: data.data.starLevel
      }
    }
  }
}

const getters = {
  DjQueryOrder: state => {
    return state.orderNum
  },
  DjBudgetCost: state => {
    return state.budgetCost
  },
  DjOrderInfo: state => {
    return state.orderDetails
  },
  DjPayInfo: state => {
    return state.payInfo
  },
  DjQueryAllOrder: state => {
    return state.AllOrder
  },
  DjQueryReview: state => {
    return state.queryReview
  },
  DJOrderFee: state => state.orderFee // 支付信息
}

const actions = {
  DJMakeAnAppointment ({commit}, obj) { // 下单
    daijia.makeAnAppointment(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
      commit('DJMakeAnAppointment', data)
    })
  },
  queryOrder ({commit}, obj) { // 查询订单
    daijia.queryOrder(obj, (data) => {
      commit('queryOrder', data)
    })
  },
  DjBudgetCost ({commit}, obj) { // 获取预算费用
    daijia.budgetCost(obj, (data) => {
      commit('DjBudgetCost', data)
    })
  },
  DjOrderInfo ({commit}, obj) { // 获取单个订单
    initdata.getOrderFindOne(obj, (data) => {
      commit('DjOrderInfo', data)
    })
  },
  putCancelOrder ({commit}, obj) { // 取消订单
    initdata.putCancelOrder(obj, (state) => {
      if (state && obj.fn) {
        obj.fn(state)
      }
    })
  },
  DjBalancePay ({commit}, obj) { // 根据 id 支付结算 代驾订单
    console.log(2)
    initdata.putFinishOrder(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  DjPayInfo ({commit}, obj) { // 支付信息
    daijia.payInfo(obj, (data) => {
      commit('DjPayInfo', data)
    })
  },
  DjEvaluateOrder ({commit}, obj) { // 订单评价
    initdata.putRateOrder(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  DjQueryReview ({commit}, obj) {
    daijia.queryReview(obj, (data) => {
      commit('DjQueryReview', data)
    })
  },
  DjWXPay ({commit}, obj) {
    daijia.weixinPay(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/daijia/daijia.js